import type { JSX } from "react";
import { Card } from "./ui";

interface WarningsProps {
  warnings: string[];
}

export function Warnings({ warnings }: WarningsProps): JSX.Element {
  return (
    <Card padding="none">
      <div className="border-b px-4 py-2 font-semibold text-red-600">Recommendations & Warnings</div>
      <div className="p-4">
        {warnings.length === 0 ? (
          <p className="text-sm text-gray-700">All set! No warnings.</p>
        ) : (
          <ul className="list-disc list-inside space-y-2">
            {warnings.map((msg, idx) => (
              <li key={idx} className="text-sm">{msg}</li>
            ))}
          </ul>
        )}
      </div>
    </Card>
  );
}